<script>
import Markdown from 'markdown-it'

// Create re-usable markdown renderer
const MD = new Markdown()

export default {
  computed: {
    caption() {
      return this.state.caption ?
        MD.render(this.state.caption) : null
    }
  },
  name: 'candela-component',
  props: {
    frame: {type: Number, default: () => 0},
    id: {type: String, default: () => null},
    settings: {type: Object, default: () => ({})},
    title: {type: String, default: () => 'Untitled Component'},
    type: {type: String, default: () => 'candela-component'}
  }
}
</script>

<template><div/></template>
